<template>
	<div class="marquee-wrapper">
		<div class="partners-section-title">{{ $t("app.partners.title") }}</div>
		<div class="marquee">
			<ul class="marquee-content desktop">
				<li><img src="@/assets/image/partners/partner2.png" alt="" /></li>
				<li><img src="@/assets/image/partners/partner5.png" alt="" /></li>
				<li><img src="@/assets/image/partners/partner3.png" alt="" /></li>
				<li><img src="@/assets/image/partners/partner6.svg" alt="" /></li>
				<li><img src="@/assets/image/partners/partner7.jpg" alt="" /></li>
				<li><img src="@/assets/image/partners/partner1.png" alt="" /></li>
				<li><img src="@/assets/image/partners/partner4.png" alt="" /></li>
				<li><img src="@/assets/image/partners/partner3.png" alt="" /></li>
				<li><img src="@/assets/image/partners/partner6.svg" alt="" /></li>
				<li><img src="@/assets/image/partners/partner1.png" alt="" /></li>

				<!-- overlaping pictures  -->
				<li><img src="@/assets/image/partners/partner2.png" alt="" /></li>
				<li><img src="@/assets/image/partners/partner5.png" alt="" /></li>
				<li><img src="@/assets/image/partners/partner3.png" alt="" /></li>
				<li><img src="@/assets/image/partners/partner6.svg" alt="" /></li>
				<li><img src="@/assets/image/partners/partner7.jpg" alt="" /></li>
			</ul>

			<ul class="marquee-content mobile">
				<partners-section-mobile-new />
			</ul>
		</div>
	</div>
</template>
<style scoped lang="scss">
$numberofelements: 10;

.marquee-wrapper {
	// width: 90%;
	max-width: 1920px;
	overflow: hidden;
	margin-bottom: 50px;

	.partners-section-title {
		font-family: Pelinka, sans-serif;
		font-size: 18px;
		line-height: 24px;
		font-weight: 700;
		margin: 0 0 24px;
		text-transform: uppercase;
		text-align: center;
	}

	.marquee {
		width: 99vw;
		display: flex;
		overflow: hidden;

		.marquee-content {
			height: 100%;
			list-style: none;
			min-height: 300px;
			grid-template-columns: 1fr;
			user-select: none;
			margin: auto;

			&.mobile {
				display: flex;
				min-height: unset;
			}

			&.desktop {
				display: none;
				pointer-events: none;
			}

			@media screen and (width >= 768px) {
				grid-template-rows: 100px;
				grid-template-columns: auto;
				animation: scrolling 40s linear infinite;
				grid-auto-flow: column dense;
				min-height: auto;
				margin: unset;

				&.mobile {
					display: none;
				}

				&.desktop {
					display: grid;
				}

				> * {
					height: unset;
				}
			}

			li {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 17vw;
				flex-shrink: 0;
				padding: 0 24px;

				img {
					max-width: 100%;
					max-height: 100%;
				}
			}
		}
	}
}

@media screen and (width >= 760px) {
	.marquee-wrapper {
		.partners-section-title {
			font-size: 30px;
			line-height: 38px;
			margin: 50px 0;
		}
	}
}

@media screen and (width >= 1024px) {
	.marquee-wrapper {
		margin: 0 0 100px;
		.partners-section-title {
			margin: 0 0 85px;
			font-size: 40px;
			line-height: 46px;
		}
	}
}

@media screen and (width >= 1572px) {
	.marquee-wrapper {
		.partners-section-title {
			margin: 25px 0 100px !important;
			font-size: 40px !important;
			line-height: 46px !important;
		}
	}
}

@keyframes scrolling {
	0% {
		transform: translateX(0);
	}

	100% {
		transform: translateX(calc(-1 * ($numberofelements * 17vw)));
	}
}

@media screen and (width <= 1000px) {
	.marquee {
		--marquee-item-width: 40vw;
	}
}
</style>
